import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Dropzone from "react-dropzone"
import uploadImage from "../../assets/images/uploadImage.png"
import Compressor from "compressorjs"
import Flatpickr from "react-flatpickr";
import { dateFormat, formatDateToISO } from 'pages/Common'
import { set } from 'lodash'
import Select from "react-select";
import { Categories } from 'emoji-picker-react'


const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        return {
            ...styles,
            border: "1px solid #ced4da",
            minHeight: "35px",
            padding: "3px 10px",
            fontSize: "12px",
            backgroundColor: isDisabled ? "#e9ecef" : "#fff",
            color: isDisabled ? "Black" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            pointerEvents: isDisabled ? "none" : "auto",  // Important for full disabling
            opacity: isDisabled ? 0.6 : 1,
        };
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const CreateHandWorkOrderModel = ({ modal, toggle, HandWorkOrderListApi, isEdit, editData }) => {
    const { postApi, putApi, getApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [categoriesData, setCategoriesData] = useState([])
    const [categoryError, setCategoryError] = useState(false)
    const [selectedCategoriesIds, setSelectedCategoriesIds] = useState()
    const [categoryErrorMessage, setCategoryErrorMessage] = useState(false)
    const [requiredDate, setRequiredDate] = useState(editData ? dateFormat(
        editData?.RequiredDate?.split("T")[0],
        "dd-MM-yyyy"
    ) : dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))

    useEffect(() => {
        getApi('Common/category/lookup').then(({ data, status }) => {
            if (status === 200) {
                let options = data.map((item) => ({
                    label: item.Value,
                    value: item.Key,
                    Value2: item.Value2
                }));

                if (isEdit && editData?.CategoryIds) {
                    const selectedIds = editData.CategoryIds.split(",");
                    const selectedCategories = options.filter(opt =>
                        selectedIds.includes(opt.value.toString())
                    );
                    setSelectedCategoriesIds(selectedCategories);
                }

                setCategoriesData(options)
            } else {
                toast.error(data, {
                    style: {
                        fontSize: "15px",
                    },
                })
            }
        })
    }, [])


    //  Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            OrderNo: isEdit ? editData?.OrderNo : '',
            Details: isEdit ? editData?.Details : '',
            Name: isEdit ? editData?.Name : '',
        },
        validationSchema: Yup.object({
            OrderNo: Yup.string().required("The order no. is required"),
            Details: Yup.string().required("The details is required"),
            Name: Yup.string().required("The name is required"),
        }),
        onSubmit: values => {

            if (selectedCategoriesIds.length == 0) {
                setCategoryError(true)
                setCategoryErrorMessage('The categories is required')
                return true
            }

            setformSumitLoading(true)
            if (values) {
                if (isEdit) {
                    putApi("HandWorkOrder/update", {
                        id: parseInt(editData?.Id),
                        OrderNo: values.OrderNo,
                        Name: values.Name,
                        CategoryIds: selectedCategoriesIds?.map(item => item.value).join(','),
                        Details: values.Details,
                        RequiredDate: formatDateToISO(requiredDate)
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success(`Sucessfully updated`, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            setformSumitLoading(false)
                            toggle()
                            if (HandWorkOrderListApi != '') {
                                HandWorkOrderListApi()
                            }
                            setRequiredDate(new Date())
                            validation.handleReset()
                        }
                    })
                } else {
                    postApi("HandWorkOrder/create", {
                        OrderNo: values.OrderNo,
                        Name: values.Name,
                        CategoryIds: selectedCategoriesIds?.map(item => item.value).join(','),
                        Details: values.Details,
                        RequiredDate: formatDateToISO(requiredDate)
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success(`Sucessfully created`, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            setformSumitLoading(false)
                            toggle()
                            if (HandWorkOrderListApi != '') {
                                HandWorkOrderListApi()
                            }
                            setRequiredDate(new Date())
                            validation.handleReset()
                        }
                    })
                }
            }
        },
    })

    // cancle handler
    const handleCancle = () => {
        toggle()
    }

    const handleMultiCategoriesSelected = (category) => {
        setSelectedCategoriesIds(category)
        setCategoryError(false)
        setCategoryErrorMessage('')
    }

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)
    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="defualt"
            style={{ width: !isMobile ? "700px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Handwork Order" : "Create Handwork Order"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            setRequiredDate(new Date())
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Order No.
                                    </Label>
                                    <Input
                                        name="OrderNo"
                                        placeholder="Order No."
                                        type="text"
                                        rows={4}
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.OrderNo}
                                        invalid={
                                            validation.touched.OrderNo && validation.errors.OrderNo
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.OrderNo && validation.errors.OrderNo ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.OrderNo}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={9}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Name
                                    </Label>
                                    <Input
                                        name="Name"
                                        placeholder="Name"
                                        type="text"
                                        rows={4}
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Name}
                                        invalid={
                                            validation.touched.Name && validation.errors.Name
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Name && validation.errors.Name ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Name}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={3}>
                                <FormGroup className="mb-2">
                                    <div>
                                        <Label htmlFor="FollowupValidation1Custom01" className="required">
                                            Required Date
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    // enableTime: true,
                                                    dateFormat: "d-m-Y",
                                                    disableMobile: true
                                                }}
                                                value={requiredDate}
                                                onChange={(e) => { setRequiredDate(e) }}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                            <Col md={9}>
                                <Label htmlFor="validationCustom03" className="required">
                                    Categories
                                </Label>
                                <Select
                                    unstyled
                                    isMulti
                                    isDisabled={editData != null && (editData?.Status == 4 || editData?.Status == 5)}
                                    styles={categoryError ? colourStyles1 : colourStyles}
                                    value={selectedCategoriesIds}
                                    onChange={(e) => handleMultiCategoriesSelected(e)}
                                    options={categoriesData}
                                    className="select2-selection"
                                />
                                {categoryError ? (
                                    <div className="name-required">
                                        {categoryErrorMessage}
                                    </div>
                                ) : null}
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Details
                                    </Label>
                                    <Input
                                        name="Details"
                                        placeholder="Enter detail"
                                        type="textarea"
                                        rows={4}
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Details}
                                        invalid={
                                            validation.touched.Details && validation.errors.Details
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Details && validation.errors.Details ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Details}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>

                        <div className="text-end">
                            {isEdit ? (
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    onClick={handleCancle}
                                >
                                    Cancle
                                </Button>
                            ) : (
                                <Button
                                    user="secondary"
                                    className="btn btn-primary me-2 btn-sm "
                                    type="reset"
                                >
                                    Reset
                                </Button>
                            )}
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    color="secondary"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    user="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                    color="primary"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default CreateHandWorkOrderModel